
      import Sunny from './sunny.vue'
      import type { App, Plugin } from 'vue'

      export const SunnyPlugin: Plugin = {
        install(app: App) {
          app.component('Sunny', Sunny)
        },
      }
      export { Sunny }
      